import { render, staticRenderFns } from "./customer-dialog.vue?vue&type=template&id=cf30aefe"
import script from "./customer-dialog.vue?vue&type=script&lang=js"
export * from "./customer-dialog.vue?vue&type=script&lang=js"
import style0 from "./customer-dialog.vue?vue&type=style&index=0&id=cf30aefe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports